import React, { useState } from 'react';
import Section from './Section';
import { useQuotedAdd } from './hooks';
import { avDomain, avLine, avLineId, avBlocker } from '../../lib/cartAiVisibility';
import { input, addBtn, hint, muted, refusal } from './styles';

// Standalone AI Visibility for any domain, monthly (src/lib/cartAiVisibility.js).
// Works on an account or a prospect cart; squish-backend prices it when added
// and says why when it can't be sold.
export default function AiVisibilitySection(props) {
  return (
    <Section title="AI Visibility for any domain">
      <AiVisibilityBody {...props} />
    </Section>
  );
}

function AiVisibilityBody({ accountId, prospect, isInvoice, onAdd }) {
  const [text, setText] = useState('');
  const { add, busy, error, clearError } = useQuotedAdd({ accountId, prospect: prospect || null, onAdd });
  const blocker = avBlocker({ isInvoice, input: text });
  const domain = avDomain(text);
  const empty = !text.trim();

  async function addIt() {
    if (blocker || busy) return;
    if (await add(avLine(domain), avLineId(domain))) setText('');
  }

  return (
    <>
      <div style={{ display: 'flex', gap: 6 }}>
        <input
          value={text}
          onChange={e => { setText(e.target.value); clearError(); }}
          onKeyDown={e => e.key === 'Enter' && addIt()}
          placeholder="example.com"
          disabled={isInvoice}
          style={{ ...input, flex: 1, fontFamily: 'var(--mono)' }}
        />
        <button onClick={addIt} disabled={!!blocker || busy} style={{ ...addBtn, padding: '6px 14px', opacity: blocker || busy ? 0.5 : 1 }}>
          {busy ? 'Pricing…' : '+ Add'}
        </button>
      </div>
      {/* An empty box needs no telling off; the disabled button says enough. */}
      {blocker && (!empty || isInvoice) && <div style={{ ...muted, marginTop: 6 }}>{blocker}</div>}
      {error && <div style={refusal}>⚠ {error}</div>}
      <div style={hint}>Monthly, for a site hosted anywhere. A site we host gets AI Visibility as an add-on on its plan instead.</div>
    </>
  );
}
